// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as BadgeUtils from "../utils/BadgeUtils.bs.js";
import * as Caml_int32 from "../../../../node_modules/rescript/lib/es6/caml_int32.js";
import * as RewardMilestone from "../domain/types/RewardMilestone.bs.js";

function getProgressBar(currentPoints, currentMilestonePoints, remainingPoints) {
  return String(Caml_int32.div(Math.imul(currentPoints - currentMilestonePoints | 0, 100), (currentPoints - currentMilestonePoints | 0) + remainingPoints | 0)) + "%";
}

function getMarkerPosition(currentPoints, currentMilestonePoints, remainingPoints) {
  return String(Caml_int32.div(Math.imul(currentPoints - currentMilestonePoints | 0, 100), (currentPoints - currentMilestonePoints | 0) + remainingPoints | 0)) + "%";
}

function RnrMilestoneComponent(Props) {
  var viewModel = Props.viewModel;
  var content = Props.content;
  var _badge = viewModel.milestoneDetails.secondNextMilestone;
  var _badge$1 = viewModel.milestoneDetails.secondNextMilestone;
  var _badge$2 = viewModel.milestoneDetails.secondNextMilestone;
  var badge = viewModel.milestoneDetails.secondNextMilestone;
  return React.createElement("div", {
              className: "milestones__container"
            }, React.createElement("div", {
                  className: "milestones__journey",
                  style: {
                    width: _badge !== undefined ? (
                        viewModel.milestoneDetails.showLocked ? "250vw" : "175vw"
                      ) : (
                        viewModel.milestoneDetails.showLocked ? "175vw" : "100vw"
                      )
                  }
                }, viewModel.milestoneDetails.pointsToNextMilestone > 0 ? React.createElement("div", {
                        className: "milestones__points-remain milestones__points-remain__1"
                      }, React.createElement("div", {
                            className: "milestones__points-triangle"
                          }), React.createElement("div", {
                            className: "milestones__points-box"
                          }, Curry._1(content.getMilestonePointsRemaining, String(viewModel.milestoneDetails.pointsToNextMilestone)))) : null, _badge$1 !== undefined ? React.createElement("div", {
                        className: "milestones__points-remain milestones__points-remain__2"
                      }, React.createElement("div", {
                            className: "milestones__points-triangle"
                          }), React.createElement("div", {
                            className: "milestones__points-box"
                          }, Curry._1(content.getMilestonePointsRemaining, String(viewModel.milestoneDetails.pointsToSecondNextMilestone)))) : null, React.createElement("div", {
                      className: "milestones__current-milestone"
                    }, React.createElement("div", {
                          className: "milestones__badge"
                        }, React.createElement("img", {
                              className: "milestones__badge-img",
                              src: BadgeUtils.getBadge(viewModel.milestoneDetails.currentMilestone)
                            })), React.createElement("div", {
                          className: "milestones__badge-name"
                        }, RewardMilestone.toMultilangString(viewModel.milestoneDetails.currentMilestone, content))), viewModel.milestoneDetails.pointsToNextMilestone > 0 ? React.createElement("div", {
                        className: "milestones__current-path"
                      }, React.createElement("div", {
                            className: "milestones__progress-bar",
                            style: {
                              width: getProgressBar(viewModel.cycleAgg.totalPoints, viewModel.milestoneDetails.pointsOfCurrentMilestone, viewModel.milestoneDetails.pointsToNextMilestone)
                            }
                          }), React.createElement("div", {
                            className: "milestones__point-marker",
                            style: {
                              left: getMarkerPosition(viewModel.cycleAgg.totalPoints, viewModel.milestoneDetails.pointsOfCurrentMilestone, viewModel.milestoneDetails.pointsToNextMilestone)
                            }
                          }, ">")) : null, viewModel.milestoneDetails.pointsToNextMilestone > 0 ? React.createElement("div", {
                        className: "milestones__current-milestone"
                      }, React.createElement("div", {
                            className: "milestones__badge milestones__future"
                          }, React.createElement("img", {
                                className: "milestones__badge-img",
                                src: BadgeUtils.getBadge(viewModel.milestoneDetails.nextMilestone)
                              })), React.createElement("div", {
                            className: "milestones__badge-name"
                          }, RewardMilestone.toMultilangString(viewModel.milestoneDetails.nextMilestone, content))) : null, _badge$2 !== undefined ? React.createElement("div", {
                        className: "milestones__current-path"
                      }) : null, badge !== undefined ? React.createElement("div", {
                        className: "milestones__current-milestone"
                      }, React.createElement("div", {
                            className: "milestones__badge milestones__future"
                          }, React.createElement("img", {
                                className: "milestones__badge-img",
                                src: BadgeUtils.getBadge(badge)
                              })), React.createElement("div", {
                            className: "milestones__badge-name"
                          }, RewardMilestone.toMultilangString(badge, content))) : null, viewModel.milestoneDetails.showLocked ? React.createElement("div", {
                        className: "milestones__current-path"
                      }) : null, viewModel.milestoneDetails.showLocked ? React.createElement("div", {
                        className: "milestones__current-milestone"
                      }, React.createElement("div", {
                            className: "milestones__badge"
                          }, React.createElement("img", {
                                className: "milestones__badge-img",
                                src: BadgeUtils.lockBadge
                              })), React.createElement("div", {
                            className: "milestones__badge-name"
                          }, content.milestoneDetails.locked)) : null));
}

var make = RnrMilestoneComponent;

export {
  getProgressBar ,
  getMarkerPosition ,
  make ,
  
}
/* react Not a pure module */
